import {Address} from "./Address";

export class InsuredDetails {
    insuredId: string;
    firstName: string;
    lastName: string;
    middleName: string;
    prefixName: string;
    suffixName: string;
    gender: number;

    birthState: string;
    birthCountry: string;
    employmentType: string;
    occupation: string;
    maritalStatus: number;
     emailAddress: string;
    address: Address;
    phoneNumber: string;
    phoneNumber2: string;
    phoneNumber3: string;
    public dateOfBirth: Date;
    public driverLicenseState: string;
    public driverLicenseNumber: string;
    public ssn: string;
    public annualIncome: number;
    public netWorth: number;
    constructor() {
         this.insuredId = '';
        // this.address = '';
        // this.city = '';
        // this.state = '';
        // this.zipCode = '';
        this.address = new Address();
        this.emailAddress = '';
        this.phoneNumber = '';
        this.firstName = '';
        this.lastName = '';
        this.middleName = '';
        this.prefixName = '';
        this.suffixName = '';
        this.dateOfBirth = new Date(1900, 1, 1);
        this.driverLicenseState = '';
        this.driverLicenseNumber = '';
        this.ssn = '';
        this.gender = 0;
        this.employmentType = '';

        this.birthCountry = '';
        this.birthState = '';
        this.occupation = '';
        this.maritalStatus = 0
        this.phoneNumber2 = '';
        this.phoneNumber3 = '';
        this.annualIncome = 0;
        this.netWorth = 0;
        this.emailAddress = '';
    }
}
